/*
 MapMarker Module

 */

import DetailApiManager from '../detailApiManager'

const MapMarker = (function(DetailApiManager) {
    // ================== VARIABLE ================== //
    var _static_url;
    var _translation = {};

    // ================== CONSTRUCTOR ================== //
    function MapMarker(data) {
        this.id = data.id;
        this.cruises_data = {};
        this.cruises_list = [];
        this.starting_port = undefined;
        this.infoWindowHtml = undefined;
        this.updateToken = 0;
        this.pos = data.pos;
        this.cruiseNb = 0;
        this.sharing_type = undefined;
    };

    // ================== STATIC METHOD ================== //
    MapMarker.setStaticUrls = function(urls) {
        _static_url = urls;
    };

    MapMarker.seti18nParam = function(data) {
        for (var key in data)
            _translation[key] = data[key];
    };

    // ================== PUBLIC METHOD ================== //
    MapMarker.prototype.updateCruiseList = function(cruise_list, callback) {
        this.updateToken += 1;
        this.cruises_data = {};
        this.cruises_list = cruise_list;
        this.cruiseNb = cruise_list.length;

        var currentToken = this.updateToken;
        var dataToGet = cruise_list.length;
        var dataGet = 0;

        for (var i = 0; i < cruise_list.length; i++) {
            dataGet += 1
            if (dataGet == dataToGet && currentToken == this.updateToken) {
                callback(this)
            }
        }
    };

    MapMarker.prototype.updateCruiseData = function(callback) {
        this.updateToken += 1;
        this.cruises_data = {};
        var currentToken = this.updateToken;
        var dataToGet = this.cruises_list.length;
        var dataGet = 0;

        function onGetData() {
            dataGet += 1;
            if (dataGet == dataToGet && currentToken == this.updateToken) {
                this.infoWindowHtml = this.toHtml()
                callback(this)
            }
        }

        for (var i = 0; i < this.cruises_list.length; i++)
           _getinfo.apply(this, [this.cruises_list[i], onGetData, this]);

    };

    // Generate html for InfoWindows content (see google map api);
    MapMarker.prototype.toHtml = function() {
        var first = true;
        var count = 0;
        var r = '';
        var carousel_id = 'carousel_' + Math.random().toString(36).substr(2, 9);
        r += '<div class="thumb-map">' +
            '    <div id="'+carousel_id+'" class="carousel slide" data-ride="carousel">' +
            '        <div class="carousel-inner" role="listbox">';
        for (var key in this.cruises_data) {
            var curr_data = this.cruises_data[key];
            r += _cruiseHtml.apply(this, [curr_data, this.sharing_type, first]);
            count += 1;
            first = false;
        }
        if (count > 1) {
            r += '<a class="carousel-control-prev" href="#'+carousel_id+'" role="button" data-slide="prev">' +
                '    <span class="carousel-control-prev-icon" aria-hidden="true"></span>' +
                '</a>' +
                '<a class="carousel-control-next" href="#'+carousel_id+'" role="button" data-slide="next">' +
                '    <span class="carousel-control-next-icon" aria-hidden="true"></span>' +
                '</a>';
        }
        r += '        </div>' +
            '    </div>' +
            '</div>';
        return r;
    };

    MapMarker.prototype.display = function(searchMap, sharing_type) {
        this.sharing_type = sharing_type
        this.googleMapMarker = searchMap.createMarker(this);
        /*
        Looks like it's recreated each time so else part is never ran
        if (this.googleMapMarker == undefined) {
            this.googleMapMarker = searchMap.createMarker(this);
        } else {
            this.googleMapMarker.setLabel(String(this.cruiseNb));
            // this.googleMapMarker.updateInfoWindow(this.infoWindowHtml);
            searchMap.addToMap(this.googleMapMarker);
        }
        */
    };

    // ================== PRIVATE METHOD ================== //
    function _getinfo(id, callback, target) {
        DetailApiManager.getCruiseDetail(id, target, function(data) {
            this.cruises_data['cruise_' + id] = data;
            this.cruises_data['cruise_' + id].id = id;
            if (this.starting_port == undefined) {
                this.starting_port = data.starting_port;
            }
            callback.apply(target);
        });
    }

    function _cruiseHtml(cruise_data, sharing_type, first) {
        var r;
        r = '<div class="carousel-item' + (first ? ' active' : '') + '">' +
            '    <div class="marker-container">' +
            '        <a class="d-block cruise-item" href="' + cruise_data.card_url + '" target="_blank" style="background-image:url(\'' + cruise_data.card_photo_url + '\')" title="' + cruise_data.card_title + '">' +
            '            <div class="cruise-info-overlay">' +
            '                <div class="marker-title">' + cruise_data.card_title + '</div>' +
            '                <div class="bottom-price">' + _getPrice.apply(this, [cruise_data, sharing_type]) + '</div>' +
            '                <div class="skipper-identity">' +
            '                    <div class="title-photo">' +
            '                        <div class="skipper-photo-circle" style="background-image:url(\'' + cruise_data.card_skipper_photo_url + '\')"></div>' +
            '                    </div>' +
            '                    <div class="skipper-first-name">' + cruise_data.card_skipper_name + '</div>' +
            '                </div>' +
            '            </div>' +
            '        </a>' +
            '    </div>' +
            '</div>';
        return r;
    }

    function _getPrice(cruise_data, sharing_type) {
        if (sharing_type == 'private')
            return _privatePrice.apply(this, [cruise_data]);
        else
            return _sharedPrice.apply(this, [cruise_data]);
    }

    function _privatePrice(cruise_data) {
        return '<span class="number">' + _translation['from'] + ' ' + cruise_data.card_min_private_price + '<span class="currency">€</span></span>' +
            '<span class="price-description"> - ' + cruise_data.card_right_info + '</span>';
    }

    function _sharedPrice(cruise_data) {
        return '<span class="number">' + _translation['from'] + ' ' + cruise_data.card_min_shared_price + '<span class="currency">€</span></span>' +
            '<span class="price-description"> - ' + cruise_data.card_right_info + '</span>';
    }

    function _duration(cruise_data) {
        // Deprecated
        r = cruise_data.duration + ' ';
        if (cruise_data.flex_duration > 0)
            r += _translation['to'] + ' ' + (cruise_data.duration + cruise_data.flex_duration) + ' ' + _translation['day(s)'];
        else
            r += _translation['day(s)'];
        return r;
    }

    return MapMarker;

})(DetailApiManager);

export default MapMarker


// WEBPACK FOOTER //
// ./search/static/search/js/objects/mapMarker.js